module.exports = {
  imgs:{
    favicon:'http://pics.sosho.cn/ow-shupl-favicon.png',
    headerLogo:'http://pics.sosho.cn/ow-shupl-header-logo-1.png'
  },
  cid: 832,
  ids: {
    customize_nav: 173,
    introduce: 131,
    donate_community: 0,
    donate_method: 132,
    donate_project: 172,
    friendlyLink: 169,
    home_picture: 165,
    notice: 170
  },
  api: 'https://admin.sosho.cn/server/api/',
  mw: 'https://h5.sosho.cn/',
  footer:`Copyright  ©  上海政法学院  沪ICP备05052051号<br>
    联系地址：上海市青浦区外青松公路7989号 联系电话：(021)39225000`
};



// WEBPACK FOOTER //
// ./custom/config.js